<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <div>
      <div class="bg-dark m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60 align-items-center justify-content-center">
            <div class="col-md-6 text-center text-white">
              <div class="bg-white rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center" style="width:64px;height:64px;">
                <i class="fe fe-user text-dark" style="font-size:1.8rem;"></i>
              </div>
              <div class="h5 mb-2">{{ auth_user.full_name }}</div>
              <span v-if="auth_user.status == 'active'">
                <span class="badge badge-soft-success px-3 py-2 my-2" style="border-radius:20px;font-size:0.8rem;">
                  <i class="fe fe-check-circle mr-1"></i> Active
                </span>
              </span>
              <span v-else-if="auth_user.status">
                <span class="badge badge-soft-warning px-3 py-2 my-2" style="border-radius:20px;font-size:0.8rem;">
                  <i class="fe fe-alert-circle mr-1"></i> Inactive
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <section class="pull-up">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <div class="card m-b-30">
                <div class="card-header">
                  <h6 class="mb-0"><i class="fe fe-user text-info mr-2"></i>Enrollee Profile</h6>
                </div>

                <div class="card-body row">
                  <div class="col-md-3 text-center border-right pt-3">
                    <img
                      :src="`${auth_user.image_url}`"
                      class="rounded-circle mb-3"
                      style="width:100px;height:100px;object-fit:cover;"
                      onerror="this.onerror=null; this.src='/claimify_logo.png'"
                    />
                    <p class="font-weight-bold mb-0">{{ auth_user.firstname }} {{ auth_user.lastname }}</p>
                    <small class="text-muted">Enrollee</small>
                  </div>

                  <div class="col-md-9 p-0">
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-user text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Full Name</p>
                          <p class="font-weight-bold mb-0">{{ auth_user.firstname }} {{ auth_user.lastname }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-credit-card text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Enrollee ID</p>
                          <p class="font-weight-bold mb-0">{{ auth_user.id_card_number }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-phone text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Phone Number</p>
                          <p class="font-weight-bold mb-0">{{ auth_user.phone_number }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-gift text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Date of Birth</p>
                          <p class="font-weight-bold mb-0">{{ auth_user.dob | moment("dddd, MMMM Do YYYY") }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start" v-if="auth_user.userprovider">
                        <i class="fe fe-home text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Provider</p>
                          <p class="font-weight-bold mb-0">{{ auth_user.userprovider.agency_name }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start" v-if="auth_user.usertpa">
                        <i class="fe fe-shield text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">HMO</p>
                          <p class="font-weight-bold mb-0">{{ auth_user.usertpa.organization_name }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-user text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Gender</p>
                          <p class="font-weight-bold mb-0">{{ auth_user.gender }}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal fade" id="example_01" tabindex="-1" role="dialog" aria-labelledby="example_02"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
              <div class="modal-content">
                <div class="container-fluid">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <div class="row">
                    <div class="col-md-12 p-t-20 p-b-20">
                      <video id="video" width="100%" height="auto" autoplay></video>
                      <p>
                        <!-- <button id="snap" class="bg-navy btn btn-flat">Snap Photo</button> -->
                        <button @click="takePic" class="bg-navy btn btn-flat">
                          Snap Photo
                        </button>
                        <button type="button" class="btn btn-info" name="button" @click="savePic">
                          Save pic
                        </button>
                      </p>
                      <!-- <p> i am image  <img :src="imagefile" alt=""> </p> -->
                      <!-- <p>{{imagefile}}</p> -->

                      <canvas id="canvas" width="720px" height="550px"></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal Ends -->
        </div>

        <div class="vld-parent">
          <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin
  // import { WebCam } from "vue-web-cam";

  export default {
    components: {
      Navbar,
      Loading,
    },
    data() {
      return {
        user: null,
        auth_user: "",
        notes: "",
        medications: "",
        image: "",
        edit: false,
        isLoading: false,
        fullPage: true,
        agency_id: "",
        imagefile: "",
        pictureShower: true,
      };
    },
    mounted() {
      //
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/user-no-auth/${this.$route.params.id}`)
        .then((response) => {
          this.auth_user = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    methods: {
      attachPic(event) {
        this.user = JSON.parse(localStorage.getItem("user"));

        console.log(event);
        // let files = event.target.files
        // let filename = event.target.files[0].name
        this.image = event.target.files[0];
        this.uploadPic();
      },
      uploadPic() {
        this.isLoading = true;
        this.user = JSON.parse(localStorage.getItem("user"));

        var formData = new FormData();
        formData.append("user_image", this.image);
        formData.append("dependant_id", this.$route.params.id);
        this.axios
          .post(
            "/api/v1/auth/uploadDependantImage",
            // {user_image: this.image, dependant_id: this.$route.params.id}
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$breadstick.notify("Profile Image changed Successfully!", {
              position: "top-right",
            });
            this.fetchUser();
          });
      },
      takePic() {
        var video = document.getElementById("video");
        var canvas = document.getElementById("canvas");
        var context = canvas.getContext("2d");

        context.drawImage(video, 0, 0, 640, 480);

        // get image
        var image = new Image();
        image.src = canvas.toDataURL("image/png");
        console.log(image);
        localStorage.setItem("snap", this.imagefile.src);
        this.imagefile = image.src;

        // upload image

        // end of upload image
      },

      savePic() {
        this.axios
          .post(`/api/v1/auth/uploadcustomerpicImage`, {
            user_image: this.imagefile,
            user_id: this.$route.params.id,
          })
          .then((response) => {
            console.log(response);
            this.$breadstick.notify("Profile Image changed Successfully!", {
              position: "top-right",
            });
            this.fetchUser();
          })
          .catch((error) => {
            console.error(error);
          });
      },

      fetchUser() {
        this.axios
          .get(`/api/v1/user-no-auth/${this.$route.params.id}`)
          .then((response) => {
            this.auth_user = response.data.user;
            console.log(this.auth_user);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      uploadPicSnapped() {
        this.isLoading = true;
        let snap = localStorage.getItem("snap");

        var formData = new FormData();
        formData.append("user_image", snap);
        this.axios
          .post("/api/v1/auth/uploadUserImage", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$breadstick.notify("Profile Image changed Successfully!", {
              position: "top-right",
            });
            // this.getUser()
          });
      },
    },
    created() {
      this.fetchUser();
    },
  };
</script>
<style>
  .spacer {
    margin-left: 15px;
  }

  .spacer-top-bottom {
    margin-top: 7px;
    margin-bottom: 7px;
  }

  #container {
    margin: 0px auto;
    width: 500px;
    height: 375px;
    border: 10px #333 solid;
  }

  #videoElement {
    width: 500px;
    height: 375px;
    background-color: #666;
  }
</style>